import constants from '../constants';
import { getElementId, getElementSizes, hasLockedParent, isMarkedForAdjacentPage } from '../../helpers';
import { Api } from '../../../../../typings/api';
import { DuplicatedItemInSpreadConfig } from '../html';

export interface SlideData extends Api.AspDriveResourceItemLight {
	id: string;
	slideText?: SlideTextData;
}

export interface SlideTextData {
	value: string;
	position: SlideTextPosition;
	font: SlideTextFont;
}

export interface SlideTextPosition {
	x: SlideTextXPosition;
	y: SlideTextYPosition;
}

export enum SlideTextXPosition {
	LEFT = 'LEFT',
	CENTER = 'CENTER',
	RIGHT = 'RIGHT',
}

export enum SlideTextYPosition {
	TOP = 'TOP',
	CENTER = 'CENTER',
	BOTTOM = 'BOTTOM',
	ABOVE_SLIDE = 'ABOVE_SLIDE',
	UNDER_SLIDE = 'UNDER_SLIDE',
}

interface SlideTextFont {
	family: string;
	size: number; // px
	color: string; // rgba
	backgroundColor?: string; // rgba
	shadowColor?: string; // rgba
}

export interface ImportingSlideData extends SlideData {
	file?: File;
}

export interface SlidersConfig {
	[key: string]: SlideData[] | {
		slides: SlideData[];
		settings?: SliderSettingsData;
	}; // new format after v3.55
}

interface SliderSettingsData {
	scaleImage?: boolean;
}

export interface SliderConfig {
	id: string;
	idInConfigs: string;
	className: string;
	page: number;
	isVisible: boolean;
	deps: string[];
	importingSlides: ImportingSlideData[];
	width: number;
	height: number;
	isEditedFromBackoffice?: boolean;
}

interface SlidersData {
	items: SliderConfig[];
	duplicatedItemsInSpread: DuplicatedItemInSpreadConfig[];
	isError: boolean;
}

export enum SliderElementDataAttribute {
	hidden = 'data-hidden', // is set when slider is hidden
	deps = 'data-deps', // is set to element to allow a server to add slider resources to publication dependencies
}

const getConfig = (element: HTMLDivElement, page: number, css: string): SliderConfig => {
	const id = getElementId(element);
	const filteredClassName = element.className.split(' ').find(className => (
		className.includes(constants.sliderClassName)
	)) || '';

	const isVisible = !(element.getAttribute(SliderElementDataAttribute.hidden) &&
		element.getAttribute(SliderElementDataAttribute.hidden) === 'true');
	const depsAttr = element.getAttribute(SliderElementDataAttribute.deps);
	const deps = depsAttr ? depsAttr.split(';') : [];
	const { width, height } = getElementSizes(id, css);

	return {
		page,
		id,
		idInConfigs: filteredClassName,
		className: filteredClassName,
		isVisible,
		deps,
		importingSlides: [],
		width,
		height,
	};
};

export default (page: number, pageIndexInSpread: number, htmlDocument: Document, css: string): SlidersData => {
	const items: SliderConfig[] = [];
	const duplicatedItemsInSpread: DuplicatedItemInSpreadConfig[] = [];
	let isError: boolean = false;

	const sliderElements = ([
		...htmlDocument.querySelectorAll(`[class*=${constants.sliderClassName}]`),
	] as HTMLDivElement[]).filter(element => !hasLockedParent(element));

	try {
		sliderElements.forEach((element) => {
			const config = getConfig(element, page, css);
			items.push(config);

			if (isMarkedForAdjacentPage(config.className, pageIndexInSpread)) {
				duplicatedItemsInSpread.push({ page, id: config.id, className: config.className });
			}
		});
	} catch (err) {
		isError = true;
	}

	return {
		items,
		duplicatedItemsInSpread,
		isError,
	};
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/utils/indesignEditor/editableSliders/getData.ts